// test1298
(1298 && 0);
